import 'polyfills/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import FaqPage from 'components/Landing/FaqPage/FaqPage';

import { registerComponents } from '../src/registrations';

registerComponents({ FaqPage });
